import { createContext } from 'react'

/**
 * CartContext
 * Create Cart context for custom hook
 */
const CartContext = createContext({
  carts: {},
  cartIds: {},
  dineInStagingCart: {},
  findOrCreateCart: () => {},
  updateCart: () => {},
  updateDineInStagingCart: () => {},
  updateIsolateCart: () => {},
  getCurrentCommerceChannel: () => { },
  getCartError: () => { },
  getCartLineAvailableQuantity: () => { },
  getCartTotalItemsCount: () => { },
  getSkuTotalQuantityInCart: () => { },
  getCart: () => { },
  getCartId: () => { },
  getParams: () => { },
  isCartCompleted: () => { },
  isCartFreezed: () => { },
  fetchCart: () => { },
  fetchIsolateCart: () => { },
  createCart: () => { },
  createIsolateCart: () => { },
  clearDineInStagingCart: () => { },
  checkout: () => { },
  mergeCart: () => { },
  refreshCarts: () => { },
  refreshCartsInProgress: false,
  initRefreshCartsReady: false,
  resetCart: () => { },
  cartsTotalItemsCount: 0,
  totalItemsCount: 0,
})

export default CartContext
